import React from 'react'
import { Navbar } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import SealBlack from './seal-black.png'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'

const NavBrand = ({
    to,
}) => {
    return (
        <LinkContainer to={to}>
            <Navbar.Brand className='text-center'>
                <img
                    src={SealBlack}
                    width="60"
                    height="60"
                    className="d-inline-block align-top"
                    alt="DSHA Applied Wellness"
                    title='DSHA Applied Wellness'
                />
            </Navbar.Brand>
        </LinkContainer>
    )
}

export default NavBrand